import { create ,StateCreator} from 'zustand';

type State = {
  currentAppInView: string;
  previousAppInView: string | null;
  walkmeScript: string | null,
  setCurrentAppInView: (newValue: string) => void;
  setPreviousAppInView: (newValue: string) => void;
  setWalkmeLoaded: (newValue: boolean) => void;
  walkmeLoaded: boolean
};

const getWalkmeScript = () => {
    const srcMap = new Map();
  srcMap.set("unify",`/thirdParty/walkme.${process.env.REACT_APP_ENV}.min.js`);
    srcMap.set("P100534",'https://cdn.walkme.com/users/98a4751b53984289893f77d7a0c57515/test/walkme_98a4751b53984289893f77d7a0c57515_https.js');
    srcMap.set("P100274",'https://cdn.walkme.com/users/98a4751b53984289893f77d7a0c57515/walkme_98a4751b53984289893f77d7a0c57515_https.js');
    return srcMap;
}

const storeCreator: StateCreator<State> = (set,get) => ({
  currentAppInView:'unify',
  previousAppInView: 'unify',
  walkmeScript:`/thirdParty/walkme.${process.env.REACT_APP_ENV}.min.js`,
  walkmeLoaded: false,

  setCurrentAppInView: (val:string) => {
    const srcMap = getWalkmeScript();
    let value = srcMap.get(val) ? val  : 'unify';
    const scriptPath = srcMap.get(value);
    if(get().currentAppInView !== value){
        window._walkMe?.removeWalkMe?.();
        set(() => ({
        previousAppInView: get().currentAppInView,
        currentAppInView: value,
        walkmeScript: scriptPath
      }));
    }
   },
    setPreviousAppInView: (previousApp:string) => set({ previousAppInView: previousApp }),
    setWalkmeLoaded: (loaded:boolean) => set({walkmeLoaded:loaded})

});

export const useHelpStore = create<State>(storeCreator);